import { pluralize } from '@/utils/pluralize';
import { BuilderConfig, PackConfig } from '@/services/static/packs/types';

export const DEFAULT_ADD_TO_CART_TEXT: string = 'Get Started by Adding to Pack';

export const getAddToCartStatus = (builderConfig: BuilderConfig, packConfig: PackConfig) => {
	let buttonText: string = 'Add Pack To Cart';
	let disabled: boolean = false;

	if (!packConfig?.selectedProducts || packConfig.selectedProducts.length === 0) {
		buttonText = DEFAULT_ADD_TO_CART_TEXT;
		disabled = true;
	} else if (
		// the builder config has a minimum and it's not yet met
		builderConfig?.productCountMin &&
		packConfig.selectedProducts?.length < builderConfig.productCountMin
	) {
		const remainingProducts = builderConfig.productCountMin - packConfig.selectedProducts.length;
		const pluralProducts = pluralize('product', remainingProducts);

		buttonText = `Add ${remainingProducts} more ${pluralProducts} to pack`;
		disabled = true;
	} else if (
		// the builder config requires extra items and they're not in the pack yet
		builderConfig.extraItems &&
		(!packConfig.selectedExtras ||
			builderConfig.extraItems.length !== packConfig.selectedExtras.length)
	) {
		buttonText = `Add all extras to cart`;
		disabled = true;
	} else if (
		packConfig.packSize?.quantity &&
		packConfig.selectedProducts?.length < packConfig.packSize.quantity
	) {
		const remainingProducts = packConfig.packSize.quantity - packConfig.selectedProducts.length;
		const pluralProducts = pluralize('product', remainingProducts);
		buttonText = `Add ${remainingProducts} more ${pluralProducts} to pack`;
		disabled = true;
	} else if (packConfig.selectedProducts?.length > 0 && builderConfig.isSpecialPack !== true) {
		buttonText = `Add ${packConfig.selectedProducts.length} Pack To Cart`;
	}

	return { buttonText, disabled };
};
